












import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { RectangleLayer } from "@/model/document2/page/surface/design/layer/rectangleLayer";
import { CircleLayer } from "@/model/document2/page/surface/design/layer/circleLayer";
import { PolygonLayer } from "@/model/document2/page/surface/design/layer/polygonLayer";

import { ColorConstruct } from "@/utilityModels/colorConstruct";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class FlipController extends Vue 
{
    static readonly PRINT_FLIP_ON = "反転印刷ON";
    static readonly PRINT_FLIP_OFF = "反転印刷OFF";

    private get flipText()
    {
        return this.$store.getters.userConfig.isPrintFlip ? FlipController.PRINT_FLIP_ON : FlipController.PRINT_FLIP_OFF;
    }

    private changeFlip()
    {
        var parameter = {};
        parameter["isFlip"] = !this.$store.getters.userConfig.isPrintFlip;
        this.$emit("doCommand", "setPrintFlip", parameter);
    }
}
